import { BookOpen, MessageSquare, Vote } from "lucide-react";
import { Link } from "react-router";

import { StatusBadge } from "@/components/status-badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useHealth, useMe } from "@/lib/api";

// TEMPLATE_TODO: replace this landing page with your app's home surface. It
// renders inside the AppShell (sidebar + top bar), so only page content here.
const PROJECT_NAME = "Vision Deliver Intelligence";

export function HomePage() {
  const { data: health } = useHealth();
  const { data: me } = useMe();

  const backendStatus = health?.status ?? "unreachable";

  return (
    <div className="mx-auto max-w-4xl px-6 py-12">
      <div className="text-center">
        <h2 className="font-heading text-primary text-3xl font-bold">Welcome to {PROJECT_NAME}</h2>
        <p className="text-muted mt-4">
          Start building something great. This is your blank canvas.
        </p>
        <p className="text-muted mt-2 text-sm">
          Backend status:{" "}
          <span className={backendStatus === "ok" ? "text-jj-green-03" : "text-destructive"}>
            {backendStatus}
          </span>
        </p>
      </div>

      {/* Shared demo toolkit shortcuts — replace alongside the hero above. */}
      <div className="mt-12 grid gap-4 sm:grid-cols-3">
        <Link to="/guide" className="group">
          <Card className="h-full transition-shadow group-hover:shadow-md">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-base">
                <BookOpen className="text-primary h-4 w-4" />
                Guide
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted text-sm">
                Walk first-time viewers through what this demo shows and where to click.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Card className="h-full">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <MessageSquare className="text-primary h-4 w-4" />
              Feedback
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted text-sm">
              The edge tab on the right collects feedback with screenshots on every page.
            </p>
          </CardContent>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <Vote className="text-primary h-4 w-4" />
              Audience voting
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted text-sm">
              {me?.role === "admin"
                ? "Open the voting panel from the sidebar to show the QR code and live results."
                : "Presenters share a QR code so the audience can score this demo live."}
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="text-muted mt-10 flex items-center justify-center gap-2 text-xs">
        <StatusBadge kind="live" label="Real data" />
        <StatusBadge kind="mock" />
        <span>— badge legend used across demo surfaces</span>
      </div>
    </div>
  );
}
